import { useState, useEffect, Fragment } from 'react';
import TextInformation from '../../../../components/TextInformation/TextInformation';
import {
  SmallHeightDivider,
} from '../../../../theme/Styles';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from '../../styles/ServiceRequestedDetailsStyles';
import { Button, Dialog, DialogContent, IconButton, Slide, Stack, Toolbar } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import SubServiceCard from './components/SubServiceCard/SubServiceCard';
import { TabContext, TabPanel } from '@mui/lab';
import { StyledTab, StyledTabList, Header, StyledCloseIcon } from './styles/SubServicesStyles'
import ServiceDescription from './subViews/ServiceDescription/ServiceDescription';
import Details from './subViews/details/Details';
import ComplaintsAndClaims from './subViews/complaintsAndClaims/ComplaintsAndClaims';
import Payments from './subViews/payments/Payments';
import RequestService from './subViews/requestService/RequestService';
import { getRequestDetail, requestConfirmation } from '../../../../api/ServiceRequestedDetails';
import { cacheConfig } from '../../../../cacheConfig';
import ActionsRequired from './subViews/actionsRequired/ActionsRequired';
import { MenuOptions } from './SubServicesConstants';
import Messages from './subViews/messages/Messages';
import CenterLoading from '../../../../components/CenterLoading/CenterLoading';
import DeskNotification from '../../../../components/DeskNotification/DeskNotification';

import FONTS_FAMILY from '../../../../theme/FontsFamily';
import { SweetAlert } from '../../../../components/SweetAlert/SweetAlert';
import COLORS from '../../../../theme/Colors';
import { HideGlobalLoading, ShowGlobalLoading } from '../../../../redux/actions/UiActions';
import { useSnackbar } from 'notistack';
function SubServices() {
  const history = useHistory();
  const { requestID } = useParams();
  const queryClient = useQueryClient();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalInformationVisible, setIsModalInformationVisible] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [selectedSubService, setSelectedSubService] = useState();
  const dispatch = useDispatch();
  const requestData = queryClient.getQueryData(['serviceRequestedDetail', requestID]);

  const userData = queryClient.getQueryData(['userData']);

  const { data: subServiceRequestedDetail, isLoading: subServiceRequestedDetailLoading, refetch: subServiceRequestedDetailRefetch, isFetching: subServiceRequestedDetailIsFetching } = useQuery(
    ['subServiceRequestedDetail', selectedSubService?.request_id],
    async () => {
      try {
        const response = await getRequestDetail(
          selectedSubService?.request_id,
          userData.payload.citizen_id
        );
        return response;
      } catch (error) {
        history.push('/app/home');
      }
    },
    {
      staleTime: cacheConfig.staleTimeForRequestedServiceDetail,
      enabled: false
    }
  );

  const handleModalFormClose = () => {
    setIsModalFormVisible(false)
  }

  const handleModalInformationClose = () => {
    setIsModalInformationVisible(false)
    if (params.sonId) {
      history.push(`/app/serviceRequestedDetails/${requestID}`);
    }
    setTimeout(() => {
      setCurrentTab(1)
    }, 200);
  }

  const handleTabPositionByRequiredActionID = (requiredActionID) => {
    setCurrentTab(MenuOptions.details);
    if (requiredActionID == 1) {
      setCurrentTab(MenuOptions.actionRequired);
    }
    if (requiredActionID == 3) {
      setCurrentTab(MenuOptions.messages);
    }
    //Action required Payment
    if (requiredActionID == 5) {
      setCurrentTab(MenuOptions.payment);
    }

    if (requiredActionID == 7) {
      setCurrentTab(MenuOptions.payment);
    }

    if (requiredActionID == 10) {
      setCurrentTab(MenuOptions.requiredForm);
    }
  }
  const handleModalTab = (event, newValue) => {
    setCurrentTab(newValue)
  }

  const handleInformationClick = (serviceData) => {
    setSelectedSubService(serviceData)
    setIsModalInformationVisible(true)
    if (serviceData.requested /* && serviceData.request_action_id != 8 */) {
      handleTabPositionByRequiredActionID(serviceData.request_action_id)
    }
  }

  const handleRequestClick = (serviceData) => {

    setSelectedSubService(serviceData)
    setIsModalFormVisible(true)
  }

  const handleOpenSonInformationByParams = (sonId) => {
    const serviceData = requestData.father_data.find((service) => service.request_id == sonId);
    if (serviceData) {
      setSelectedSubService(serviceData)
      setIsModalInformationVisible(true)
      handleTabPositionByRequiredActionID(serviceData.request_action_id)
    }
  }
  //This function is executed in required actions for remove messages
  const handleSubServiceMutation = (requestSubServiceID) => {
    handleModalInformationClose();
    queryClient.invalidateQueries('requestsList');
    queryClient.invalidateQueries(['serviceRequestedDetail', requestID]);
    queryClient.invalidateQueries(['subServiceRequestedDetail', requestSubServiceID]);
    history.push(`/app/serviceRequestedDetails/${requestID}?sonId=${requestSubServiceID}`);
  }

  //ComponentDidMount
  useEffect(() => {
    if (params?.sonId) {
      handleOpenSonInformationByParams(params?.sonId)
    }
  }, []);

  //ComponentDidUpdate
  useEffect(() => {
    if (selectedSubService !== undefined && selectedSubService !== null && selectedSubService?.requested) {
      subServiceRequestedDetailRefetch();
    }
  }, [selectedSubService]);

  // if (subServiceRequestedDetailLoading || subServiceRequestedDetailIsFetching) return <CenterLoading />

  const sendConfirmationMutation = useMutation(
    requestConfirmation,
    {
      onMutate: (req) => {
        dispatch(ShowGlobalLoading('Cargando'));
      },
    }
  );
  const handleConfirmation = async (value) => {

    try {
      SweetAlert.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        // showDenyButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar",

      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch(ShowGlobalLoading("Enviando"));

          await requestConfirmation({
            requestId: selectedSubService?.request_id,
            entityAttributeId: "logicoconfirm",
            entityAttributeValue: value
          }).then(() => {
            handleSubServiceMutation(selectedSubService?.request_id);
            setTimeout(() => {
              dispatch(HideGlobalLoading());
              window.location.reload();
            }, 500);
          });

          /*   .then(() => {
               refetch().then(() => {
                 window.location.reload();
               });
             });  */

          SweetAlert.fire({
            title: "¡Confirmado!",
            text: "Respuesta enviada",
            icon: "success",
            confirmButtonText: "Aceptar",

          });
        }
      }
      );
    } catch (error) {
      console.log(error);
      SweetAlert.fire({
        title: "Error",
        text: "Ha ocurrido un error al confirmar la acción",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } finally {

      dispatch(HideGlobalLoading());
    }

  };

  return (
    <Container>
      <TextInformation title='Trámites' content={"Puede iniciar todos los trámites con estatus Disponible"} />
      <SmallHeightDivider />
      <SmallHeightDivider />
      {
        requestData.father_data.map((service, index) => (
          <Fragment>
            <SubServiceCard
              title={service.name}
              actionRequired={service?.request_action_id}
              status={service?.status?.name}
              solutionColor={service?.status?.color}
              //date="2022-05-06 16:00:22"
              onClick={() => handleInformationClick(service)}
              onRequestClick={() => handleRequestClick(service)}
              requested={service.requested}
              percent={service.progress + "%"}
              requestCode={service.code}
              //When father status is "En Revision" the user can't request a son 
              requestEnable={service.enable}
            /* 
            requestEnable={  requestData.request.status.id == 2 ? false : service.enable}
            */
            />
            {
              requestData.father_data.length !== index + 1 &&
              <SmallHeightDivider />
            }
          </Fragment>
        ))
      }

      <Dialog
        open={isModalInformationVisible}
        onClose={handleModalInformationClose}
        //  keepMounted
        TransitionComponent={Slide}
        disableEscapeKeyDown
        fullWidth
        sx={{ zIndex: 99 }}
        maxWidth="xl"
      >
        <IconButton
          onClick={handleModalInformationClose}
          sx={{ zIndex: 99999999, display: 'flex', position: 'absolute', backgroundColor: '#FFF', alignSelf: 'flex-end', margin: '10px' }} >
          <StyledCloseIcon />
        </IconButton>
        <TabContext value={currentTab}>
          <Header>
            <Toolbar sx={{ width: '94%' }}>
              <StyledTabList TabScrollButtonProps={{ style: { color: "#FFF", marginRight: '20px' } }} variant="scrollable" scrollButtons="auto" indicatorColor="inherit" onChange={handleModalTab} >
                <StyledTab label="Información del trámite" value={1} />
                {
                  selectedSubService?.requested &&
                  <StyledTab label="Detalle de la solicitud" value={2} disabled={!selectedSubService?.requested} />
                }
                {
                  selectedSubService?.requested &&
                  <StyledTab label="Quejas y reclamaciones" value={3} disabled={!selectedSubService?.requested} />
                }
                {
                  subServiceRequestedDetail?.request?.request_actions_id == 7 &&
                  <StyledTab label="Pagos" value={4} disabled={!selectedSubService?.requested} />
                }

                {
                  subServiceRequestedDetail?.request?.request_actions_id == 3 &&
                  <StyledTab label="Mensajes" value={5} disabled={!selectedSubService?.requested} />

                }
                {
                  subServiceRequestedDetail?.request?.request_actions_id == 1 &&
                  <StyledTab label="Acciones requeridas" value={6} disabled={!selectedSubService?.requested} />
                }

              </StyledTabList>
            </Toolbar>
          </Header>
          {
            (subServiceRequestedDetailLoading || subServiceRequestedDetailIsFetching) ?
              <CenterLoading /> :
              <DialogContent>

                {subServiceRequestedDetail?.request?.request_actions &&
                  subServiceRequestedDetail.request.messages.map((message) => (
                    <DeskNotification
                      key={message.id}
                      variant={"warning"}
                      disableCloseButton={true}
                      message={message.message}
                      customActions={
                        subServiceRequestedDetail?.request?.request_actions_id == 8 && (
                          <Stack direction={"row"} marginRight={"10px"} spacing={1}>
                            <Button
                              aria-label="YES"
                              color="success"
                              size="small"
                              variant={"contained"}
                              sx={{
                                boxShadow: "none",
                                fontFamily: FONTS_FAMILY.regular.body,
                                fontWeight: 600,
                                letterSpacing: "2px"
                              }}
                              onClick={() => handleConfirmation(1)}
                            >
                              SI
                            </Button>

                            <Button
                              aria-label="NO"
                              color="error"
                              size="small"
                              variant={"contained"}
                              sx={{
                                boxShadow: "none",
                                fontFamily: FONTS_FAMILY.regular.body,
                                fontWeight: 600,
                                letterSpacing: "2px"
                              }}
                              onClick={() => handleConfirmation(2)}
                            >
                              NO
                            </Button>
                          </Stack>
                        )
                      }
                    />
                  ))}


                {/*   {
                  //ONLY MOUNT IF REQUESTID HAS AN ACTION REQUIRED
                  subServiceRequestedDetail?.request?.request_actions &&
                  <Fragment>
                    <SmallHeightDivider />
                    {
                      subServiceRequestedDetail.request.messages.map((message, index) => (
                        <Fragment>
                          <DeskNotification variant={'warning'} disableCloseButton={true}
                            message={message.message}
                          />
                          <SmallHeightDivider />
                        </Fragment>
                      ))
                    }
                    <SmallHeightDivider />
                  </Fragment>
                } */}

                <TabPanel value={MenuOptions.serviceDescription}>
                  <ServiceDescription onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>
                <TabPanel value={MenuOptions.details}>
                  <Details onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>
                <TabPanel value={MenuOptions.claims}>
                  <ComplaintsAndClaims onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>
                <TabPanel value={MenuOptions.payment}>
                  <Payments onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>
                <TabPanel value={MenuOptions.messages}>
                  <Messages onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>

                <TabPanel value={MenuOptions.actionRequired}>
                  <ActionsRequired onFinish={handleSubServiceMutation} data={selectedSubService} />
                </TabPanel>


              </DialogContent>
          }
        </TabContext>
      </Dialog>


      <Dialog
        open={isModalFormVisible}
        onClose={handleModalFormClose}
        //  keepMounted
        //I put this value for prevent sweet alert visual bugs
        style={{ zIndex: 1000 }}
        TransitionComponent={Slide}
        disableEscapeKeyDown
        fullWidth
        maxWidth="xl"
      >
        <DialogContent>
          <RequestService data={selectedSubService} onFinish={handleModalFormClose} />
        </DialogContent>
      </Dialog>

    </Container >
  );
}

export default SubServices;
